import jwt from 'jsonwebtoken';
import AccessTokenData from './AccessTokenData';
import PingAuthTokens from './PingAuthTokens';

export interface PingUser {
    email: string;
    id: string;
    organizationId: number;
    name: string;
    picture: string;
    // userRoles?: UserRoleWithPermissions[]; // Used in BrandTreez, not in PlanTreez
}

export const emptyPingUser: PingUser = {
    email: '',
    id: '',
    organizationId: 0,
    name: '',
    picture:
        'https://store-treez.s3.us-west-2.amazonaws.com' +
        '/productImages/brand/launch/c962521d-21cb-4978-a1d8-686593f99eaf.png',
    // userRoles: [],
};

export const isTreez = (user: PingUser): boolean => {
    return Boolean(user.email?.endsWith('@treez.io'));
};

export const getPingUserDetails = (tokens: PingAuthTokens): PingUser => {
    const accessTokenData: AccessTokenData = jwt.decode(tokens.accessToken) as AccessTokenData;
    // If a migrated userId string from auth0 exists, it is used in preference to the normal 'sub' field
    const userId = accessTokenData.auth0UserId || accessTokenData.sub || '';

    return {
        email: accessTokenData.email,
        organizationId: accessTokenData.organizationId || 0,
        id: userId,
        picture: emptyPingUser.picture, // dummy for now
        name: accessTokenData.email, // same as email for now
    };
};
